export enum TariffPlans {
	Demo = 'DEMO',
	Starter = 'STARTER',
	Pro = 'PRO',
	Enterprise = 'ENTERPRISE',
	EnterpriseExcel = 'ENTERPRISE + EXCEL',
	Datawiz = 'ENTERPRISE + DATAWIZ'
}